import React from "react";

const DreamCatcherResult = ({ resultData }) => {
  const resultHistory = ((resultData && resultData.length > 0) || [])
    .map((item) => Number(item.result))
    .filter((item) => item > 0);

  //console.log("DreamCatcherResult:", result);
  //console.log("Is Array?", Array.isArray(result));
  //console.log("First Item:", result?.[0]);
  console.log("RESULT DATA:", resultData);
  console.log("IS ARRAY:", Array.isArray(resultData));

  const rows = [];

  for (let i = 0; i < resultHistory.length; i += 10) {
    rows.push(resultHistory.slice(i, i + 10));
  }

  return (
    <div className="left-content">
      <div
        className="card"
        style={{
          border: "1px solid rgb(204,204,204)",
          borderRadius: "8px",
          padding: "10px",
          background: "linear-gradient(rgb(15,15,15), rgb(251,251,251))"
        }}
      >
        <div className="cardAV">
          <div className="card-headerAV">Results for Last 50 Rounds</div>

          <div class="card-bodyAV">
            <div class="rowAV">
              {resultData !== null &&
                Object.values(resultData).map((idx, data) => (
                  <div class="colAV">
                    <div
                      className={
                        idx > 2
                          ? "result-itemAV border-normal"
                          : "result-itemAV border-normal"
                      }
                    >
                      {" "}
                      {idx}
                    </div>
                  </div>
                ))}

              {/*} <div class="colAV">
                <div class="result-itemAV border-golden">20.01</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.11</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.62</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.54</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-normal">2.02</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.30</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.36</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-red">1.24</div>
              </div>
              <div class="colAV">
                <div class="result-itemAV border-normal">3.43</div>
              </div>*/}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DreamCatcherResult;